export default "__VITE_ASSET__Bg2R3x5r__"